import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Seccion1 from "../components/renew/seccion1";
import Section2 from "../components/renew/section2";
import Section3 from "../components/renew/section3";

const Renew = () => {
    return (
        <Layout>
            <Seccion1/>
            <Section2/>
            <Section3/>
        </Layout>
    );
};


const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(Renew)
